var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6736 5H1V6.54054H10.1524C10.2667 6.0015 10.4431 5.48538 10.6736 5Z",
    fill: "#317289"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5H10.6736C10.4431 5.48538 10.2667 6.0015 10.1524 6.54054H1M1 5V6.54054M1 5V3.51351C1 2.67762 1.67762 2 2.51351 2H13.3924M1 6.54054V12.4865C1 13.3224 1.67762 14 2.51351 14H13.3924M21.1139 5.87085L16.8713 10.1135L14.2852 7.52734M24 8C24 11.866 20.866 15 17 15C13.134 15 10 11.866 10 8C10 4.13401 13.134 1 17 1C20.866 1 24 4.13401 24 8Z",
    stroke: "#317289",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipt);
export default __webpack_public_path__ + "static/media/recipt.bdf3216d4fd434f93a3dbddef0af7817.svg";
export { ForwardRef as ReactComponent };